import React from "react";
import moment from "moment";
import { withRouter, BrowserRouter as Router, Route } from "react-router-dom";
import { connect } from "react-redux";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";
import DatePickerField from "../../GenericComponents/DatePickerField";
import GlobalSlider from "../../GenericComponents/GlobalSlider";
import styles from "../style";

class DayTimeSettingsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { dayTimeSettings, defaultSettings, setTime, handleSliderValues } =
      this.props;
    //console.log("defaultSettings...", defaultSettings);
    //console.log("dayTimeSettings...", dayTimeSettings);
    return (
      Object.keys(dayTimeSettings).length !== 0 && (
        <div>
          <label className={css(styles.valueLabels)}>
            select time <br />
            <span className={css(styles.subLabels)}>
              (Day time start and end times have been adjusted to reflect the
              nighttime settings)
            </span>
            <br />
            Default : (
            {moment(
              defaultSettings.DAY_TIME_START.defaultValue,
              "hh:mm:ss"
            ).format("h:mm A")}{" "}
            - {moment(
              defaultSettings.DAY_TIME_END.defaultValue,
              "hh:mm:ss"
            ).format("h:mm A")})
          </label>
          <Row style={{ alignItems: "center", marginBottom: "1em" }}>
            <Col xs={12} sm={6} md={2}>
              <DatePickerField
                name={"dayTimeStart"}
                minTime={moment(
                  dayTimeSettings.nightTimeEnd,
                  "hh:mm:ss"
                ).toDate()}
                maxTime={moment("23:55:00", "hh:mm:ss").toDate()}
                value={moment(
                  dayTimeSettings.dayTimeStart,
                  "hh:mm:ss"
                ).toDate()}
                action={setTime}
                showTimeSelect={true}
                showTimeSelectOnly={true}
                timeIntervals={5}
                timeCaption="Time"
                dateFormat="h:mm aa"
                className={"form-control"}
              />
            </Col>
            <Col
              xs={12}
              sm={6}
              md={1}
              style={{ textAlign: "center", paddingTop: "1%" }}
            >
              <label className={css(styles.valueLabels)}>to</label>
            </Col>
            <Col xs={12} sm={6} md={2}>
              <DatePickerField
                name={"dayTimeEnd"}
                minTime={moment(
                  dayTimeSettings.dayTimeStart,
                  "hh:mm:ss"
                ).toDate()}
                maxTime={moment("23:55:00", "hh:mm:ss").toDate()}
                value={moment(
                  this.props.dayTimeSettings.dayTimeEnd,
                  "hh:mm:ss"
                ).toDate()}
                action={setTime}
                showTimeSelect={true}
                showTimeSelectOnly={true}
                timeIntervals={5}
                timeCaption="Time"
                dateFormat="h:mm aa"
                className={"form-control"}
              />
            </Col>
          </Row>
          <label className={css(styles.valueLabels)}>
            degree motion sensitivity ({defaultSettings.DAY_SENSITIVITY.minValue} -{" "}
            {defaultSettings.DAY_SENSITIVITY.maxValue})<br />
            Default : {defaultSettings.DAY_SENSITIVITY.defaultValue}
          </label>
          <GlobalSlider
            name={"dayTimeSensitivity"}
            min={parseInt(defaultSettings.DAY_SENSITIVITY.minValue)}
            max={parseInt(defaultSettings.DAY_SENSITIVITY.maxValue)}
            value={dayTimeSettings.dayTimeSensitivity}
            //onChangeStart={this.handleChangeStart}
            action={handleSliderValues}
          //onChangeComplete={this.handleChangeComplete}
          />
          <label className={css(styles.valueLabels)}>
            motion duration to trigger an event ({defaultSettings.DAY_DURATION.minValue} -{" "}
            {defaultSettings.DAY_DURATION.maxValue}{" "}
            {defaultSettings.DAY_DURATION.unit})<br />
            Default : {defaultSettings.DAY_DURATION.defaultValue}
          </label>
          <GlobalSlider
            name={"dayTimeDuration"}
            min={parseInt(defaultSettings.DAY_DURATION.minValue)}
            max={parseInt(defaultSettings.DAY_DURATION.maxValue)}
            value={dayTimeSettings.dayTimeDuration}
            //onChangeStart={this.handleChangeStart}
            action={handleSliderValues}
          //onChangeComplete={this.handleChangeComplete}
          />
        </div>
      )
    );
  }
}

export default DayTimeSettingsCard;

const style = StyleSheet.create({
  title: {
    fontSize: "18px",
    color: "white",
  },
  subTitle: {
    fontSize: "12px",
    color: "white",
  },
  headerStyle: {
    background: "#0d6cbf",
    margin: "-1px",
  },
  footerStyles: {
    display: "block !important",
    textAlign: "center",
  },
});
